<template>
    <div class="main">
        <header class="header">
            <div class="bg"></div>
            <img src="../../assets/img/banner.jpg" alt="循证医学" />
            <!-- <p><img src="../../assets/img/jinru.png" alt="相关简介" /><span>相关简介</span></p> -->
        </header>
        <main id="main">
            <ul class="tit">
                <li @click="show_hide = 1" :class="show_hide === 1 ? 'active' : ''">PICO检索</li>
                <li @click="show_hide = 2" :class="show_hide === 2 ? 'active' : ''">临床查询</li>
            </ul>
            <div class="main_search_box" :class="show_hide === 1 ? 'main_active' : ''">
                <div class="search_tit">Fill in search terms</div>
                <div class="inline">
                    <span>Patient/Problem:</span>
                    <label>
                        <input type="text" placeholder="包括：疾病和人群" v-model="picoParam.condition" />
                    </label>
                </div>
                <div class="inline">
                    <span>Intervention:</span>
                    <label>
                        <input type="text" placeholder="包括：用药，治疗，诊断测试等" v-model="picoParam.intervention" />
                    </label>
                </div>
                <div class="inline">
                    <span>Compare to:</span>
                    <label>
                        <input type="text" placeholder="对比的疾病，人群或者用药等" v-model="picoParam.comparison" />
                    </label>
                </div>
                <div class="inline">
                    <span>Outcome:</span>
                    <label>
                        <input type="text" placeholder="临床预后" v-model="picoParam.outcome" />
                    </label>
                </div>
                <div class="search_bottom">
                    <div class="search_tit">Select Publication type</div>
                    <select name="NotSpecified" id="specified" v-model="picoParam.pubtype">
                        <option value="0">未指定</option>
                        <option value="1">临床试验</option>
                        <option value="2">Meta分析</option>
                        <option value="3">随机对照试验</option>
                        <option value="4">系统综述</option>
                        <option value="5">实践指南</option>
                        <option value="6">综述</option>
                    </select>
                </div>
            </div>
            <div class="main_search_box main_search_box2" :class="show_hide === 2 ? 'main_active' : ''">
                <div class="search_tit">Filter category</div>
                <van-radio-group v-model="linchuangParam.type" @change="radioChangeFun">
                    <van-radio name="1">Clinical Studies</van-radio>
                    <van-radio name="2">COVID-19</van-radio>
                </van-radio-group>
                <div class="inline">
                    <span>Filter:</span>
                    <label v-show="linchuangParam.type == 2">
                        <select name="COVIDcategory" v-model="linchuangParam.Filter">
                            <option value="general">General</option>
                            <option value="mechanism">Mechanism</option>
                            <option value="transmission">Transmission</option>
                            <option value="diagnosis">Diagnosis</option>
                            <option value="treatment" selected>Treatment</option>
                            <option value="prevention">Prevention</option>
                            <option value="case report">Case Report</option>
                            <option value="forecasting">Forecasting</option>
                        </select>
                    </label>
                    <label v-show="linchuangParam.type == 1">
                        <select name="Category" v-model="linchuangParam.Filter">
                            <option value="therapy" selected>Therapy</option>
                            <option value="clinical prediction guides">Clinical Prediction Guides</option>
                            <option value="diagnosis">Diagnosis</option>
                            <option value="etiology">Etiology</option>
                            <option value="prognosis">Prognosis</option>
                        </select>
                    </label>
                    <span v-show="linchuangParam.type == 1">Scope:</span>
                    <label v-show="linchuangParam.type == 1">
                        <select name="Scope" v-model="linchuangParam.scope">
                            <option value="broad">Broad</option>
                            <option value="narrow">Narrow</option>
                        </select>
                    </label>
                </div>
                <!-- <div class="search_tit">COVID-19 Articles</div>
                <div class="inline">
                    <span>Category:</span>
                    <label>
                        <select name="COVIDcategory" v-model="linchuangParam.COVIDcategory">
                            <option value="general">General</option>
                            <option value="mechanism">Mechanism</option>
                            <option value="transmission">Transmission</option>
                            <option value="diagnosis">Diagnosis</option>
                            <option value="treatment" selected>Treatment</option>
                            <option value="prevention">Prevention</option>
                            <option value="case report">Case Report</option>
                            <option value="forecasting">Forecasting</option>
                        </select>
                    </label>
                </div>
                <div class="search_tit">Select search criteria</div>
                <div class="inline">
                    <span>Category:</span>
                    <label>
                        <select name="Category" v-model="linchuangParam.category">
                            <option value="therapy" selected>Therapy</option>
                            <option value="clinical prediction guides">Clinical Prediction Guides</option>
                            <option value="diagnosis">Diagnosis</option>
                            <option value="etiology">Etiology</option>
                            <option value="prognosis">Prognosis</option>
                        </select>
                    </label>
                </div>
                <div class="inline">
                    <span>Scope:</span>
                    <label>
                        <select name="Scope" v-model="linchuangParam.scope">
                            <option value="Broad">Broad</option>
                            <option value="Narrow">Narrow</option>
                        </select>
                    </label>
                </div>
                 -->
                <div class="search_bottom">
                    <div class="search_tit">Fill in the search content</div>
                    <input type="text" v-model="linchuangParam.key" placeholder="请输入您要检索的内容" />
                </div>
            </div>
            <!--  <div class="select_type_box">

              </div>-->
            <div class="button_box">
                <button @click="btnClear()" class="clear">清除</button>
                <button @click="search()" class="search">检索</button>
            </div>
        </main>
    </div>
</template>

<script>
import { Dialog } from "vant";

export default {
    name: "index",
    components: {
        [Dialog.Component.name]: Dialog.Component
    },
    data() {
        return {
            show_hide: 1,
            picoParam: {
                condition: "",
                intervention: "",
                comparison: "",
                outcome: "",
                pubtype: "0"
            },
            linchuangParam: {
                key: "",
                scope: "broad",
                Filter: "therapy",
                type: "1"
            }
        };
    },
    mounted() {
        // localStorage.setItem("access-user", this.$route.query.token);
        this.$store.dispatch("actionsHead", { type: false, title: "", iconType: false });
    },
    methods: {
        radioChangeFun() {
            if (this.linchuangParam.type == 1) {
                this.linchuangParam.scope = "broad";
                this.linchuangParam.Filter = "therapy";
            }
            if (this.linchuangParam.type == 2) {
                this.linchuangParam.scope = "";
                this.linchuangParam.Filter = "treatment";
            }
        },
        btnClear() {
            this.picoParam = {
                condition: "",
                intervention: "",
                comparison: "",
                outcome: "",
                pubtype: "0"
            };
            this.linchuangParam = {
                category: "therapy",
                scope: "Broad",
                COVIDcategory: "treatment",
                type: 0,
                key: ""
            };
        },
        search() {
            if (this.show_hide === 1) {
                //pico Search
                if (this.picoParam.condition) {
                    this.$router.push({ path: "/picolist", query: this.picoParam });
                } else {
                    Dialog({ message: '"Patient/Problem"字段不能为空！' });
                }
            } else if (this.show_hide === 2) {
                //临床查询
                // console.log(this.linchuangParam);
                if (this.linchuangParam.key) {
                    this.$router.push({ path: "/picolclist", query: this.linchuangParam });
                } else {
                    Dialog({ message: "检索词不能为空！" });
                }
            }
        }
    }
};
</script>

<style scoped>
* {
    font-size: 16px;
}

select {
    background-color: #f7f7f7;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    padding-right: 14px;
}

option {
    height: 100%;
    width: 100%;
    line-height: 40px;
}

/*清除ie的默认选择框样式清除，隐藏下拉箭头*/
select::-ms-expand {
    display: none;
}

.main_active {
    display: table !important;
}

.main {
    width: 100%;
    height: auto;
    display: table;
}

.header {
    height: 132px;
    position: relative;
}

.header img {
    height: 122px;
    width: 100%;
    display: block;
}

.header p {
    position: absolute;
    right: 25px;
    bottom: 6px;
    width: auto;
    padding: 3px 10px;
    font-size: 16px;
    line-height: 30px;
    color: white;
    background-color: #1a79af;
    border-radius: 8px;
}

.header p img {
    width: 12px;
    height: 12px;
    margin-top: 9.5px;
    float: left;
}

.header p span {
    margin-left: 5px;
    display: block;
    float: right;
}

.bg {
    height: 12px;
    background-color: #f3f3f3;
}

.main_search_box {
    display: none;
    width: 90%;
    height: auto;
    margin: 15px auto auto auto;
}

.active {
    color: white !important;
    background-color: #1a79af;
}

.inline {
    width: 100%;
    height: auto;
    line-height: 40px;
}

.inline span {
    width: auto;
    padding: 0 5px;
    text-align: left;
    height: 40px;
    font-size: 16px;
    line-height: 40px;
    display: block;
}

.inline input,
.inline select {
    width: 100%;
    height: 40px;
    padding-left: 5px;
    font-size: 16px;
    line-height: 40px;
    border: solid 1px #dadada;
    border-radius: 8px;
}

.inline2 input {
    width: 100%;
    margin-left: 0;
}

.inline select {
    background: url("../../assets/img/xiala.png") no-repeat;
    background-size: 13px 13px;
    background-position: 370px 13px;
}

.inline input {
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
}

.tit {
    padding: 0;
    width: auto;
    height: 45px;
    line-height: 45px;
    display: table;
    border: 2px solid #1a79af;
    border-radius: 10px;
    margin: 39px auto auto auto;
}

.tit li {
    font-size: 16px;
    width: 6.5rem;
    float: left;
    text-align: center;
}

.tit li:nth-child(1) {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.tit li:nth-child(2) {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.search_tit {
    font-size: 22px;
    font-weight: bold;
    text-align: left;
    padding-left: 10px;
    margin: 10px 0;
    border-left: 10px solid #279ee0;
}

.main_search_box2 .inline span {
    width: 16rem;
}

.main_search_box2 .inline select {
}

#specified {
    margin-top: 10px;
    float: left;
    width: 100%;
    height: 40px;
    padding-left: 5px;
    margin-left: 0;
    line-height: 40px;
    border: solid 1px #dadada;
    border-radius: 8px;
    background: url("../../assets/img/xiala.png") no-repeat;
    background-size: 13px 13px;
    background-position: 370px 13px;
}

.search {
    width: 48%;
    float: right;
    display: table;
    height: 45px;
    background-color: #1a79af;
    border-radius: 8px;
    line-height: 45px;
    border: none;
    font-size: 16px;
    color: white;
}

.clear {
    width: 48%;
    float: left;
    display: table;
    border-radius: 8px;
    line-height: 45px;
    height: 45px;
    background-color: #289de0;
    border: none;
    font-size: 16px;
    color: white;
}

.button_box {
    width: 90%;
    margin: 35px auto;
    display: table;
}

.search_bottom {
    width: 100%;
    height: auto;
    margin: 20px auto auto auto;
    display: table;
}

.search_bottom input {
    width: 100%;
    height: 40px;
    padding-left: 5px;
    font-size: 16px;
    line-height: 40px;
    border-bottom: 1px solid #dadada;
    border-radius: 8px;
    border-top: none;
    border-left: none;
    border-right: none;
}

.van-radio-group .van-radio {
    margin-bottom: 0.5rem;
}
</style>
